export const counters = [
    { finalCount: 33099, label: " PLATES SHARED WITH LOVE", unit: "+" },
    { finalCount: 2844, label: " Students Benefited", unit: "+" },
    { finalCount: 17964, label: " Benefited People in Khusi Ferao", unit: "+" },
    { finalCount: 83, label: " Benefited People in Free Oxygen Service", unit: "+" },
    { finalCount: 91, label: " Benefited Patient in Ambulance Service", unit: "+" },
    { finalCount: 1131, label: " Benefited People in DBD Service", unit: "+" },
    { finalCount: 3161, label: " Benefited People in Bina Paysar Bazar", unit: "+" },
    { finalCount: 316, label: " Plantation in nature Bachao ", unit: "+" },
    { finalCount: 255, label: " Benefited Women in Free Sanitary Napkin Service", unit: "+" },
    { finalCount: 57945, label: " Benefited People in Covid 19 Service", unit: "+" },

  ];